import { render, staticRenderFns } from "./ApontamentoProducaoDetalheForm.vue?vue&type=template&id=c35f2814&"
import script from "./ApontamentoProducaoDetalheForm.vue?vue&type=script&lang=js&"
export * from "./ApontamentoProducaoDetalheForm.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./ApontamentoProducaoDetalheForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports